// src/contexts/vendas/NotaPagContext.js
import React, { createContext, useCallback, useContext, useReducer } from 'react';
import { buscarNotaPags, excluirNotaPag, salvarNotaPag } from '../../services/vendas/NotaPagService';
import { useAlert } from '../geral/AlertContext';
import { useMessage } from '../geral/MessageContext';
import { NotaPag } from '../../models/vendas/NotaPag';

const NotaPagContext = createContext();

const reduzirPagamentos = (estado, acao) => {
    if (acao.tipo === 'aplicar') return acao.estado;
    if (acao.tipo === 'selecionar') {
        return { ...estado, notaPagSel: typeof acao.valor === 'function' ? acao.valor(estado.notaPagSel) : acao.valor };
    }
    if (acao.tipo === 'listar') {
        const notaPags = typeof acao.valor === 'function' ? acao.valor(estado.notaPags) : acao.valor;
        return { ...estado, notaPags };
    }
    if (acao.tipo === 'salvar') {
        const existe = estado.notaPags.some(pagamento => NotaPag.mesmoPagamento(pagamento, acao.anterior));
        const notaPags = existe
            ? estado.notaPags.map(pagamento => NotaPag.mesmoPagamento(pagamento, acao.anterior) ? acao.pagamento : pagamento)
            : [...estado.notaPags, acao.pagamento];
        return {
            notaPags,
            notaPagSel: NotaPag.mesmoPagamento(estado.notaPagSel, acao.anterior) ? acao.pagamento : estado.notaPagSel
        };
    }
    return estado;
};

export const useNotaPag = () => useContext(NotaPagContext);

export const NotaPagProvider = ({ children }) => {
    const [{ notaPagSel, notaPags }, dispatch] = useReducer(reduzirPagamentos, { notaPagSel: new NotaPag(), notaPags: [] });
    const setNotaPagSel = useCallback(valor => dispatch({ tipo: 'selecionar', valor }), []);
    const setNotaPags = useCallback(valor => dispatch({ tipo: 'listar', valor }), []);
    const aplicarPagamentosFinalizacao = useCallback((pagamentos, selecionado) => {
        dispatch({ tipo: 'aplicar', estado: { notaPags: pagamentos, notaPagSel: selecionado } });
    }, []);
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();

    const fetchNotaPags = useCallback(async (notaId, { atualizarEstado = true } = {}) => {
            if (!notaId) return; 
            try {
                const result = await buscarNotaPags(notaId);
                if (atualizarEstado) setNotaPags(result || []);
                return result;          
            } catch (error) {
                console.error("Erro ao buscar pagamentos da nota:", error);
            showMessage(`Erro ao buscar pagamentos da nota! ${error?.message || error}`, 'danger');
            }
        }, []); 

    // useEffect(() => {
    //     fetchNotaPags();
    // }, [fetchNotaPags]);

    const addNotaPag = async (notaPag, { atualizarEstado = true } = {}) => {
        try {
            const result = NotaPag.reidratar(await salvarNotaPag(notaPag), [], notaPag);
            //setNotaPags([...notaPags, result]); 

            //Usa o item por que nao tem o id e precisa diferenciar
            if (atualizarEstado) dispatch({ tipo: 'salvar', pagamento: result, anterior: notaPag });
            showAlert('Pagamento adicionado com sucesso!');
            return result;
        } catch (error) {
            console.error("Erro ao adicionar pagamento:", error);
            showMessage('Erro ao adicionar pagamento!\n' + error, 'danger');
        }
    };

    const updateNotaPag = async (notaPag, { atualizarEstado = true } = {}) => {
        try {
            const result = NotaPag.reidratar(await salvarNotaPag(notaPag), [], notaPag);
            if (atualizarEstado) dispatch({ tipo: 'salvar', pagamento: result, anterior: notaPag });
            showAlert('Pagamento atualizado com sucesso!');
            return result;
        } catch (error) {
            console.error("Erro ao atualizar pagamento:", error);
            showAlert(error?.message || 'Erro ao atualizar pagamento!', 'danger');
        }
    };

    const deleteNotaPag = async (id, { atualizarEstado = true } = {}) => {
        try {
            await excluirNotaPag(id);
            if (atualizarEstado) setNotaPags(atuais => atuais.filter(n => n.id !== id));
            showAlert('Pagamento excluído com sucesso!');
            return true;
        } catch (error) {
            console.error("Erro ao excluir pagamento:", error);
            showAlert(error?.message || 'Erro ao excluir pagamento!', 'danger');
            return false;
        }
    };

    return (
        <NotaPagContext.Provider value={{ fetchNotaPags, notaPags, setNotaPags, notaPagSel, setNotaPagSel, aplicarPagamentosFinalizacao, addNotaPag, updateNotaPag, deleteNotaPag }}>
            {children}
        </NotaPagContext.Provider>
    );
};
